<template>
  <main>
    <div class="main">
      <dl class="titleTip">
        <dt>
          <span  style="color:#666;cursor: pointer" @click="$router.go(-1)">成员单位 ></span>
          <span> 成员单位详情</span>
        </dt>
        <dd></dd>
      </dl>
      <div class="mainBox" v-if="info">
        <div>
          <div class="my_title">
            单位介绍
          </div>
          <div class="my_content" style="white-space: pre-line">
            {{info.introduce ? info.introduce : '暂无单位介绍'}}
          </div>
        </div>
        <div>
          <div class="my_title" style="margin: 20px 0;">
            专家介绍
          </div>
          <div v-if="info.list.length == 0" style="color:#666;font-size: 14px;line-height: 24px;">暂无专家介绍</div>
          <div class="doctorInsMain" v-for="item of info.list" style="margin-top: 20px;padding:20px;border: solid 1px #a2b8da;box-sizing: border-box;">
            <img :src="item.head" onerror="onerror=null;this.src='https://xiongtongzi.oss-cn-shanghai.aliyuncs.com/rayplus/head/noHead.png'"/>
            <div  style="width: calc(100% - 170px);box-sizing: border-box;overflow-y: hidden;position: relative">
              <div style="color: #3f68aa;font-size: 16px;margin-bottom: 20px;">专家介绍</div>
              <div style="font-size: 16px;color:#333;margin-bottom: 5px;">{{item.name}}</div>
              <div style="color:#666;font-size: 14px;line-height: 24px;white-space: pre-wrap;" v-html="item.content"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
  export default {
    name: 'Article',
    data() {
      return {
        id: null,
        info: null
      }
    },
    created() {
      this.id = this.$route.query.id
      this.$api.getMemberList().then(r => {
        if (r.code === 1) {
          this.list = r.data.data
          let o = this.list.find((v) => {
            return v.id == this.id
          })
          this.info = o
        }
      })
    },
    methods: {
    },
    computed: {
    },
    watch: {

    },
  }

</script>
<style lang="scss" scoped>
  @import './SectionIntroductionDetail.scss';
</style>
